import React from 'react'
import './Copyright.css'

const Copyright = () => {
  return (
    <div className='Copyright'><p>©Copyright 2023-24 By Awwsome.co. All rights reserved</p></div>
  )
}

export default Copyright